const BASE_STORAGE_KEY = import.meta.env.VITE_BASE_STORAGE_KEY;
const DEFAULT_EXPIRATION_TIME = 1000 * 60 * 60 * 8; // 8 hours

const StorageService = {
	getBaseKey: () => {
		return BASE_STORAGE_KEY;
	},
	getKey: (key) => {
		return `${BASE_STORAGE_KEY}-${key}`;
	},
	getAllItems: ({ prefix = undefined, regexp = undefined }) => {
		// get all items with the base key
		const items = [];

		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i);
			if (prefix && key.startsWith(`${BASE_STORAGE_KEY}-${prefix}`)) {
				const item = localStorage.getItem(key);
				if (!item) continue;

				const { value, expiresAt } = JSON.parse(item);
				if (expiresAt !== null && expiresAt < new Date().getTime()) {
					localStorage.removeItem(StorageService.getKey(key));
					continue;
				}

				items.push(value);
				continue;
			}

			if (regexp && regexp.test(key)) {
				const item = localStorage.getItem(key);
				if (!item) continue;

				const { value, expiresAt } = JSON.parse(item);
				if (expiresAt !== null && expiresAt < new Date().getTime()) {
					localStorage.removeItem(key);
					continue;
				}

				items.push(value);
				continue;
			}
		}

		return items;
	},
	getItem: (key) => {
		const item = localStorage.getItem(StorageService.getKey(key));
		if (!item) return null;

		const { value, expiresAt } = JSON.parse(item);
		if (expiresAt !== null && expiresAt < new Date().getTime()) {
			localStorage.removeItem(StorageService.getKey(key));
			return null;
		}

		return value;
	},
	setItem: (key, value, expiresAt = new Date().getTime() + DEFAULT_EXPIRATION_TIME) => {
		const item = {
			value,
			expiresAt,
		};

		localStorage.setItem(StorageService.getKey(key), JSON.stringify(item));
	},
	removeItem: (key) => {
		localStorage.removeItem(StorageService.getKey(key));
	},
	clear: () => {
		localStorage.clear();
	},
};

export { StorageService };
